import { IDisplayVals, IBuyer, IOsl, ITeamMember, MethodOfContact, IHomesite } from "../../api/homesites/homesites.types";
import { Community } from "../../api/communities/types";
import { Note } from "../../api/homeSiteNotes/types";


export interface IHomeSitesDataIndexParams {
     id: string;
     homeSiteId: string;
     divisionCode: string;
     broadBandFlag?: string | null;
     broadBandDescription?: string | null;
     communityId: string;
     communityCode: string;
     communityName: string;
     communityPhase: string;
     communityNumber: string;
     conciergeName: string;
     conciergeEmail: string;
     conciergeSource: string;
     conciergeUserId: string;
     conciergeTeamMembers: ITeamMember[];
     displayVals: IDisplayVals;
     buyers?: IBuyer[];
     nhc?: string;
     loanStatus?: string;
     loanBuyerSigningComplete?: Date;
     loanAppraisalValue?: string;
     loanSigning?: string;
     loanOfficerName?: string;
     loanOfficerEmail?: string;
     loanConditionalApproval?: string;
     loanActualApproval?: string;
     loanApprovalSF?: string;
     loanType?: string;
     loanForeignNationalLoan?: string;
     lenderName_JDE?: string;
     lenderName_SF?: string;
     loanGrade?: string;
     loanDeclined?: string;
     loanLockExpirationDate?: string;
     contingent?: boolean;
     contingentType?: string;
     closingDocsSent?: string;
     realtorName?: string;
     realtorEmail?: string;
     homeToSell?: string;
     solarType?: string;
     totalOptions?: number;
     optionIncentive?: number;
     paymentsCollected?: number;
     paymentsRemaining?: number;
     totalPrice?: number;
     finalSalesPrice?: number;
     revenueSubtotal?: number;
     currentConstructionPhase?: string;
     preConstruction?: string;
     preDrywall?: string;
     constructionComplete?: string;
     certOfOccupancy?: string;
     electricity?: string;
     gas?: string;
     water?: string;
     flooring?: string;
     planNumber?: string;
     planDescription?: string;
     planElev?: string;
     extPkg?: string;
     intPkg?: string;
     trenchDate?: string;
     estimatedDeliverableDate?: string;
     homesiteAddress?: string;
     homesitePhase?: string;
     opportunityId?: string;
     saleDate?: string;
     closeOfEscrowEstimated?: string;
     closeOfEscrowActual?: string;
     qaWalkDate?: string;
     NHCDate?: string;
     NHCTime?: string;
     NHADate?: string;
     NHATime?: string;
     finalSignOff?: string;
     titleStatus?: string;
     titleCompany?: string;
     revisedTitleCompany?: string;
     constructionManager?: string;
     qaManager?: string;
     revisedEcoe?: string;
     delayedReason?: string;
     lockedCoe?: string;
     closingAptTime?: string;
     mortgageType?: string;
     oslLoanGrade?: string;
     ostName?: string;
     ostEmail?: string;
     osls?: IOsl[];
     coBroker?: boolean;
     homeToCloseDate?: string;
     lastContact?: string;
     contactMethod?: MethodOfContact;
     lastResetTimestamp?: Date;
     latestException?: string;
     latestNote?: string;
     numExceptions?: number;
     numNotes?: number;
     numAlerts?: number;
     ecoeMismatch?: boolean;
     milestoneProgress?: number;
     milestoneProgressCompleted?: number;
     milestoneProgressTotal?: number;
     milestoneProgressBreakdown?: Array<{ name: string; completed: number; total: number; progress: number }>;
     notesData?: Note[];
     comments?: string;
     closeOfEscrowEstimatedMortgage?: Date;
     loanGradeSFMortgage?: string;
     propertyAppraisalOrderDate?: Date;
     propertyAppraisalReceiveDate?: Date;
     cdApprovedDate?: Date;
     loanClosingDate?: Date;
     loanComment?: string;
     loanProcessorName?: string;
     lennarTrackConsent?: boolean;
     packageDeliveredToLender?: boolean;
     lenderDocsReceived?: boolean;
     homeToClose?: boolean;
     escrowClosingDate?: Date;
     escrowOfficer?: string;
}

export class HomeSitesDataIndex {

     constructor(params: IHomeSitesDataIndexParams) {
          Object.assign(this, params);
     }
     // Public properties - using definite assignment assertion since Object.assign handles initialization
     public id!: string;
     public homeSiteId!: string;
     public divisionCode!: string;
     public broadBandFlag!: string | null;
     public broadBandDescription!: string | null;
     public communityId!: string;
     public communityCode!: string;
     public communityName!: string;
     public communityPhase!: string;
     public communityNumber!: string;
     public nhc?: string;
     public conciergeName!: string;
     public conciergeEmail!: string;
     public conciergeSource!: string;
     public conciergeUserId!: string;
     public conciergeTeamMembers!: ITeamMember[];
     public displayVals!: IDisplayVals;
     public buyers?: IBuyer[];
     public loanStatus?: string;
     public loanBuyerSigningComplete?: Date;
     public loanAppraisalValue?: string;
     public loanSigning?: string;
     public loanOfficerName?: string;
     public loanOfficerEmail?: string;
     public loanConditionalApproval?: string;
     public loanActualApproval?: string;
     public loanApprovalSF?: string;
     public loanType?: string;
     public loanForeignNationalLoan?: string;
     public lenderName_JDE?: string;
     public lenderName_SF?: string;
     public loanGrade?: string;
     public loanDeclined?: string;
     public loanLockExpirationDate?: string;
     public closingDocsSent?: string;
     public contingent?: boolean;
     public contingentType?: string;
     public realtorName?: string;
     public realtorEmail?: string;
     public homeToSell?: string;
     public solarType?: string;
     public totalOptions?: number;
     public optionIncentive?: number;
     public paymentsCollected?: number;
     public paymentsRemaining?: number;
     public totalPrice?: number;
     public finalSalesPrice?: number;
     public revenueSubtotal?: number;
     public currentConstructionPhase?: string;
     public preConstruction?: string;
     public preDrywall?: string;
     public constructionComplete?: string;
     public certOfOccupancy?: string;
     public electricity?: string;
     public gas?: string;
     public water?: string;
     public flooring?: string;
     public planNumber?: string;
     public planDescription?: string;
     public planElev?: string;
     public extPkg?: string;
     public intPkg?: string;
     public trenchDate?: string;
     public estimatedDeliverableDate?: string;
     public homesiteAddress?: string;
     public homesitePhase?: string;
     public opportunityId?: string;
     public saleDate?: string;
     public closeOfEscrowEstimated?: string;
     public closeOfEscrowActual?: string;
     public qaWalkDate?: string;
     public NHCDate?: string;
     public NHCTime?: string;
     public NHADate?: string;
     public NHATime?: string;
     public finalSignOff?: string;
     public titleStatus?: string;
     public titleCompany?: string;
     public revisedTitleCompany?: string;
     public constructionManager?: string;
     public qaManager?: string;
     public revisedEcoe?: string;
     public delayedReason?: string;
     public lockedCoe?: string;
     public closingAptTime?: string;
     public mortgageType?: string;
     public oslLoanGrade?: string;
     public ostName?: string;
     public ostEmail?: string;
     public osls?: IOsl[];
     public coBroker?: boolean;
     public homeToCloseDate?: string;
     public lastContact?: string;
     public contactMethod?: MethodOfContact;
     public lastResetTimestamp?: Date;
     public latestException?: string;
     public latestNote?: string;
     public numExceptions?: number;
     public numNotes?: number;
     public numAlerts?: number;
     public ecoeMismatch?: boolean;
     public milestoneProgress?: number;
     public milestoneProgressCompleted?: number;
     public milestoneProgressTotal?: number;
     public milestoneProgressBreakdown?: Array<{ name: string; completed: number; total: number; progress: number }>;
     public notesData?: Note[];
     public comments?: string;
     public closeOfEscrowEstimatedMortgage?: Date;
     public loanGradeSFMortgage?: string;
     public propertyAppraisalOrderDate?: Date;
     public propertyAppraisalReceiveDate?: Date;
     public cdApprovedDate?: Date;
     public loanClosingDate?: Date;
     public loanComment?: string;
     public loanProcessorName?: string;
     public lennarTrackConsent?: boolean;
     public packageDeliveredToLender?: boolean;
     public lenderDocsReceived?: boolean;
     public homeToClose?: boolean;
     public escrowClosingDate?: Date;
     public escrowOfficer?: string;

     // Static factory method for creating from homeSite and community data
     static createHomeSiteDataIndex(homeSite: IHomesite, community?: Community): HomeSitesDataIndex {
          return new HomeSitesDataIndex({
               id: homeSite.id,
               homeSiteId: homeSite.homeSiteId,
               divisionCode: homeSite.divisionCode,
               broadBandFlag: community?.broadBandFlag || null,
               broadBandDescription: community?.broadBandDescription || null,
               communityId: community?.id ?? '',
               communityCode: community?.communityCode || '',
               communityName: community?.communityName || '',
               communityPhase: community?.communityPhase || '',
               communityNumber: community?.communityNumber || '',
               conciergeName: homeSite.conciergeName,
               conciergeEmail: homeSite.conciergeEmail,
               conciergeSource: homeSite.conciergeSource,
               conciergeUserId: homeSite.conciergeUserId,
               conciergeTeamMembers: homeSite.conciergeTeamMembers,
               displayVals: homeSite.displayVals,
               buyers: homeSite.buyers,
               nhc: homeSite.nhc,
               loanStatus: homeSite.loanStatus,
               loanBuyerSigningComplete: homeSite.loanBuyerSigningComplete,
               loanAppraisalValue: homeSite.loanAppraisalValue,
               loanSigning: homeSite.loanSigning,
               loanOfficerName: homeSite.loanOfficerName,
               loanOfficerEmail: homeSite.loanOfficerEmail,
               loanConditionalApproval: homeSite.loanConditionalApproval,
               loanActualApproval: homeSite.loanActualApproval,
               loanApprovalSF: homeSite.loanApprovalSF,
               loanType: homeSite.loanType,
               loanForeignNationalLoan: homeSite.loanForeignNationalLoan,
               lenderName_JDE: homeSite.lenderName_JDE,
               lenderName_SF: homeSite.lenderName_SF,
               loanGrade: homeSite.loanGrade,
               loanDeclined: homeSite.loanDeclined,
               loanLockExpirationDate: homeSite.loanLockExpirationDate,
               contingent: homeSite.contingent,
               contingentType: homeSite.contingentType,
               closingDocsSent: homeSite.closingDocsSent,
               realtorName: homeSite.realtorName,
               realtorEmail: homeSite.realtorEmail,
               homeToSell: homeSite.homeToSell,
               solarType: homeSite.solarType,
               totalOptions: homeSite.totalOptions,
               optionIncentive: homeSite.optionIncentive,
               paymentsCollected: homeSite.paymentsCollected,
               paymentsRemaining: homeSite.paymentsRemaining,
               totalPrice: homeSite.totalPrice,
               finalSalesPrice: homeSite.finalSalesPrice,
               revenueSubtotal: homeSite.revenueSubtotal,
               currentConstructionPhase: homeSite.currentConstructionPhase,
               preConstruction: homeSite.preConstruction,
               preDrywall: homeSite.preDrywall,
               constructionComplete: homeSite.constructionComplete,
               certOfOccupancy: homeSite.certOfOccupancy,
               electricity: homeSite.electricity,
               gas: homeSite.gas,
               water: homeSite.water,
               flooring: homeSite.flooring,
               planNumber: homeSite.planNumber,
               planDescription: homeSite.planDescription,
               planElev: homeSite.planElev,
               extPkg: homeSite.extPkg,
               intPkg: homeSite.intPkg,
               trenchDate: homeSite.trenchDate,
               estimatedDeliverableDate: homeSite.estimatedDeliverableDate,
               homesiteAddress: homeSite.homesiteAddress,
               homesitePhase: homeSite.homesitePhase,
               opportunityId: homeSite.opportunityId,
               saleDate: homeSite.saleDate,
               closeOfEscrowEstimated: homeSite.closeOfEscrowEstimated,
               closeOfEscrowActual: homeSite.closeOfEscrowActual,
               qaWalkDate: homeSite.qaWalkDate,
               NHCDate: homeSite.NHCDate,
               NHCTime: homeSite.NHCTime,
               NHADate: homeSite.NHADate,
               NHATime: homeSite.NHATime,
               finalSignOff: homeSite.finalSignOff,
               titleStatus: homeSite.titleStatus,
               titleCompany: homeSite.titleCompany,
               revisedTitleCompany: homeSite.revisedTitleCompany,
               constructionManager: homeSite.constructionManager,
               qaManager: homeSite.qaManager,
               revisedEcoe: homeSite.revisedEcoe,
               delayedReason: homeSite.delayedReason,
               lockedCoe: homeSite.lockedCoe,
               closingAptTime: homeSite.closingAptTime,
               mortgageType: homeSite.mortgageType,
               oslLoanGrade: homeSite.oslLoanGrade,
               ostName: homeSite.ostName,
               ostEmail: homeSite.ostEmail,
               osls: homeSite.osls,
               coBroker: homeSite.coBroker,
               homeToCloseDate: homeSite.homeToCloseDate,
               lastContact: homeSite.lastContact,
               contactMethod: homeSite.contactMethod,
               lastResetTimestamp: homeSite.lastResetTimestamp,
               latestException: homeSite.latestException,
               latestNote: homeSite.latestNote,
               numExceptions: homeSite.numExceptions,
               numNotes: homeSite.numNotes,
               numAlerts: homeSite.numAlerts,
               comments: homeSite.comments,
               closeOfEscrowEstimatedMortgage: homeSite.closeOfEscrowEstimatedMortgage,
               loanGradeSFMortgage: homeSite.loanGradeSFMortgage,
               propertyAppraisalOrderDate: homeSite.propertyAppraisalOrderDate,
               propertyAppraisalReceiveDate: homeSite.propertyAppraisalReceiveDate,
               cdApprovedDate: homeSite.cdApprovedDate,
               loanClosingDate: homeSite.loanClosingDate,
               loanComment: homeSite.loanComment,
               loanProcessorName: homeSite.loanProcessorName,
               lennarTrackConsent: homeSite.lennarTrackConsent,
               packageDeliveredToLender: homeSite.packageDeliveredToLender,
               lenderDocsReceived: homeSite.lenderDocsReceived,
               homeToClose: homeSite.homeToClose,
               escrowClosingDate: homeSite.escrowClosingDate,
               escrowOfficer: homeSite.escrowOfficer
          });
     }
}

export type Combined = {
     data: HomeSitesDataIndex[];
     communities: import("../../api/communities/types").Community[];
     pending: boolean;
     error: unknown;
     isSuccess: boolean;
};
